export default "__VITE_ASSET__CuF9O3gQ__"